export default {"src":"/_next/static/media/PRODEGE.44b2c2f5.svg","height":123,"width":440,"blurWidth":0,"blurHeight":0};